import React from 'react';
import { Route, Routes } from 'react-router';
import NotFound from '../pages/NotFound';
import Index from '../pages/Index';
import Dashboard from '../pages/Dashboard';
import EmbedChat from '../pages/EmbedChat';
import SignIn from '../pages/SignIn';
import SignUp from '../pages/SignUp';
import { SnackbarProvider } from "notistack";
import CrawlingChatbotPrivateRoute from '../Auth/CrawlingChatbotPrivateRoute';
import { CrawlingChatbotAuthProvider } from '../Auth/CrawlingChatbotAuthProvider'
import CrawlingChatbotLandingPage from '../pages/CrawlingChatbotLandingPage';

export default function CrawlingChatbotRoute() {
  return (
    <CrawlingChatbotAuthProvider>
      <div>
        <SnackbarProvider  
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Routes>
          <Route path="/crawling">
            <Route path="*" element={<NotFound />} />
            <Route path="crawlingChatbotUtility" element={<CrawlingChatbotLandingPage />} />
            <Route path="signup" element={<SignUp />} />
            <Route path="signin" element={<SignIn />} />
            <Route path="index" element={
              <CrawlingChatbotPrivateRoute>
                <Index />
              </CrawlingChatbotPrivateRoute>
              } />
            <Route path="dashboard" element={
              <CrawlingChatbotPrivateRoute>
                <Dashboard />
              </CrawlingChatbotPrivateRoute>
              } />
            <Route path="embed-chat/:useremail" element={<EmbedChat />} />
          </Route>
        </Routes>
        </SnackbarProvider>
      </div>
    </CrawlingChatbotAuthProvider>
  );
}
